import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PortfolioService } from '../../services/portfolio.service';
import { DataLayerService } from '../../services/data-layer.service';
import { AnalyticsUtils } from '../../services/analytics-utils';
import { lastValueFrom } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-connect-iframe-modal',
    templateUrl: './connect-iframe-modal.component.html',
    styleUrls: ['./connect-iframe-modal.component.scss'],
    standalone: false
})
export class ConnectIframeModalComponent implements OnInit {
   iframeUrl: string = '';
   isRefetchAccountLoader: boolean = false;
   @Input() module: any;
   status: string = 'PENDING';
   pleaseWaitBtn: boolean = false;
   countdownTimer: number = 5;
   private isBrowser: boolean;

   constructor(
      public activeModal: NgbActiveModal,
      private router: Router,
      private portfolioService: PortfolioService,
      private dataLayerService: DataLayerService,
      private analyticsUtils: AnalyticsUtils,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
   }

   ngOnInit(): void {
      // console.log(this.module);
      if (this.isBrowser) {
         window.addEventListener(
            'message',
            this.handleMessageEvent.bind(this),
            false
         );
      }
      // this.status = 'SUCCESS'
      // this.startPleaseWaitTimer()
   }

   async startPleaseWaitTimer() {
      this.countdownTimer = 5;
      this.pleaseWaitBtn = true;
      const intervalId = setInterval(() => {
         if (this.countdownTimer === 0) {
            clearInterval(intervalId);
            this.pleaseWaitBtn = false;
            this.portfolioService.triggerDataReload();
         } else {
            this.countdownTimer--;
         }
      }, 1000);
   }

   ngOnDestroy(): void {
      if (this.isBrowser) {
         window.removeEventListener(
            'message',
            this.handleMessageEvent.bind(this),
            false
         );
      }
   }

   closeModal(): void {
      this.activeModal.dismiss();
      //  console.log('closed');
   }

   async goToPortfolio() {
      this.isRefetchAccountLoader = true;
      try {
         await lastValueFrom(this.portfolioService.refetchPortfoliosList());
         // this.router.navigate(['/cabinet/portfolio-dashboard']);
         const targetUrl = '/portfolio-dashboard';

         this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
               this.router.navigate([targetUrl]);
            });
         this.portfolioService.triggerDataReload();
         this.closeModal();
      } catch {
         console.log('something went wrong');
      } finally {
         this.isRefetchAccountLoader = false;
      }
   }

   async startTrading() {
      this.isRefetchAccountLoader = true;
      try {
         await lastValueFrom(this.portfolioService.refetchPortfoliosList());
         this.activeModal.dismiss();
      } catch {
         console.log('something went wrong');
      } finally {
         this.isRefetchAccountLoader = false;
      }
   }

   private handleMessageEvent(e: MessageEvent<unknown>) {
      if (e.data) {
         const data = e.data as any;

         if (data.status === 'SUCCESS' || data.status === 'ERROR') {
            this.status = data.status;
         }

         if (e.data === 'CLOSED' || e.data === 'CLOSE_MODAL') {
            if (this.status !== 'SUCCESS') {
               this.status = 'ERROR';
            } else {
               // console.log(data)
               this.status = 'SUCCESS';
               this.startPleaseWaitTimer();
               this.dataLayerService.portfolioLinkingSuccessEvent('');
               this.analyticsUtils.portfolio_linking_success('');
            }
         }
      }
   }
}
